import { useState } from "react";
import Image from "components/Elements/Image/Image";
import useMediaQueries from "hooks/useMediaQueries";
import Icon from "components/Elements/Icon/Icon";
import { useMail } from "contexts/mailContext/mailContext";

interface UploadCompleteHeaderI {
  handleCloseSidebar: () => void;
}

const UploadCompleteHeader = ({
  handleCloseSidebar,
}: UploadCompleteHeaderI) => {
  const { mobileCondition } = useMediaQueries();
  const { getMailMetaData } = useMail();
  const [isMainImageLoaded, setIsMainImageLoaded] = useState(false);

  const handleMainImageLoad = () => {
    setIsMainImageLoaded(true);
  };

  const notValidSize =
    getMailMetaData().expectedFilesCount > getMailMetaData().filesCount;

  return (
    <div className={`upload-complete-sidebar-header`}>
      <>
        <div className="close-button">
          <Icon name={"x"} onClick={handleCloseSidebar} />
        </div>

        <Image
          name={`${mobileCondition ? "cloud-gradient" : "cloud_success"}`}
          ext={`${mobileCondition ? "png" : "svg"}`}
          className="cloud-icon"
          onLoad={handleMainImageLoad}
        />
        <Image
          name="cloud_shadow_success"
          ext="svg"
          className="cloud-shadow-icon"
        />
        <Image
          name="blue-envelop"
          ext="png"
          className={`blue-envelop-icon ${isMainImageLoaded ? "animate" : ""}`}
        />
        {!notValidSize ? (
          <Image
            name="mark-done"
            ext="png"
            className={`mark-done-icon ${isMainImageLoaded ? "animate" : ""}`}
          />
        ) : (
          <Icon
            name="warning"
            red
            iconClass={`warning-icon ${isMainImageLoaded ? "animate" : ""}`}
          />
        )}
        <Image
          name="right-paper-airplane"
          ext="svg"
          className={`right-paper-airplane ${
            isMainImageLoaded ? "animate" : ""
          }`}
        />
        <Image
          name="left-paper-airplane"
          ext="svg"
          className={`left-paper-airplane ${
            isMainImageLoaded ? "animate" : ""
          }`}
        />
        <Image
          name="picture-icon"
          ext="svg"
          className={`picture-icon ${isMainImageLoaded ? "animate" : ""}`}
        />
        <Image
          name="music-icon"
          ext="svg"
          className={`music-icon ${isMainImageLoaded ? "animate" : ""}`}
        />
      </>
    </div>
  );
};

export default UploadCompleteHeader;
